
export function contact() {
    document.addEventListener(
        'wpcf7mailsent',
        function (event) {
            const originalUrl = window.location.href;
            const modifiedUrl = originalUrl.replace(/\/[^\/]*\/?$/, '/');
            setTimeout(() => {
                location = `${modifiedUrl}/thanks`;
            }, 500);
        },
        false
    );

    function changeFile() {
        $(".c-form_file input[type='file']").on('change', function () {
            var fileName = $(this).val().split('\\').pop();
            $(this).closest('.c-form_file').find('.c-form_file__txt').text(fileName);
            $(this).closest('.c-form_file').find('.c-form_file__txt').css('color', '#000000');
            $(this).closest('.c-form_file').parent().find('.notes').css('opacity', '0');
            setTimeout(setPositonErrorMessage, 100);
        });
    }
    $(function () {
        changeFile();
        $('.wpcf7 input[type="radio"]').on('change', function (e) {
            e.stopPropagation(); 
        });
    });

    const loadPostcode = function () {
        $("[name='postcode']").keyup(function (e) {
            e.stopPropagation();
            let zip = this.value.replace(/[^\d]+/g, '');
            this.value = zip
                .split(/^(\d{3})/)
                .filter(Boolean)
                .join('-');
    
            AjaxZip3.zip2addr('postcode', '', 'address', 'address');
            if (this.value.length < 9) {
                $("[name='address']").val('');
            }
            return false;
        });
    };
    $(function () {
        loadPostcode();
    });

    $(function () {
        function updateSelectColor(select) {
            $(select).css('color', $(select).val() ? '#000000' : '');
        }
    
        $('select')
            .each(function () {
                updateSelectColor(this);
            })
            .change(function () {
                updateSelectColor(this);
            });
    });

}